import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FooterComponent } from './shared/footer.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule, FooterComponent, LoaderComponent, Toast],
  template: `
    <div class="app-container">
      <p-toast></p-toast>
      <app-loader />
      <main class="main-content">
        <router-outlet />
      </main>
      <app-footer />
    </div>
  `,
  styles: [`
    .app-container {
      display: flex;
      flex-direction: column;
      min-height: 100dvh;
    }
    .main-content {
      flex: 1 0 auto;
      display: flex;
      flex-direction: column;
      background-color: var(--background-color);
    }
  `]
})
export class AppComponent {
  title = 'proyecto-angular';
  constructor() {}
}
